/**
 * Получает значение для сортировки из объекта
 * @param {Object} item - объект данных
 * @param {string} key - ключ поля
 * @returns {any} - значение для сортировки
 */
export function getSortValue(item, key) {
    const value = item?.[key];

    // Для денежных полей
    if (key === 'summa' || key === 'summa_work') {
        return value === null || value === undefined || value === ''
            ? null
            : Number(String(value).replace(/\s+/g, '').replace(',', '.'));
    }

    // Для числовых полей
    if (key === 'number') {
        return value ?? null;
    }

    return value ?? null;
}

/**
 * Сортирует массив данных
 * @param {Array} data - массив для сортировки
 * @param {string} sortKey - ключ сортировки
 * @param {string} sortDir - направление ('asc' или 'desc')
 * @param {Function|null} customGetter - функция для получения значения (item, key) => value
 * @returns {Array} - отсортированный массив
 */
export function sortArray(data, sortKey, sortDir = 'asc', customGetter = null) {
    const items = [...(data || [])];

    return items.sort((a, b) => {
        const aValue = customGetter ? customGetter(a, sortKey) : getSortValue(a, sortKey);
        const bValue = customGetter ? customGetter(b, sortKey) : getSortValue(b, sortKey);

        if (aValue === bValue) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        if (typeof aValue === 'number' && Number.isFinite(aValue) && typeof bValue === 'number' && Number.isFinite(bValue)) {
            return sortDir === 'asc' ? aValue - bValue : bValue - aValue;
        }

        return sortDir === 'asc'
            ? String(aValue).localeCompare(String(bValue), 'ru', { numeric: true, sensitivity: 'base' })
            : String(bValue).localeCompare(String(aValue), 'ru', { numeric: true, sensitivity: 'base' });
    });
}
